import { Injectable, signal } from '@angular/core';

export interface ConfirmOptions {
  header?: string;
  message?: string;
  icon?: string;
  acceptLabel?: string;
  rejectLabel?: string;
  /** 'danger' paints the accept button red. */
  tone?: 'brand' | 'danger';
  accept?: () => void;
  reject?: () => void;
}

/** One-at-a-time confirmation dialog, rendered by `app-confirm-host` (replaces PrimeNG ConfirmationService). */
@Injectable({ providedIn: 'root' })
export class ConfirmService {

  readonly current = signal<ConfirmOptions | null>(null);

  confirm(options: ConfirmOptions): void {
    this.current.set(options);
  }

  accept(): void {
    const options = this.current();
    this.current.set(null);
    options?.accept?.();
  }

  reject(): void {
    const options = this.current();
    this.current.set(null);
    options?.reject?.();
  }
}
